import { CloseIcon, FilterIcon } from '@assets/icons'
import styled from '@emotion/styled'
import { Button, Drawer } from '@mui/material'

const FilterButtonStyled = styled.div`
	display: flex;
	align-items: center;
`

const StyledTextButton = styled(Button)`
	display: flex;
	align-items: center;
	text-decoration: underline;
	&:hover {
		cursor: pointer;
	}
`

const StyledCloseIcon = styled(CloseIcon)`
	margin-right: 0.8rem;
`

const StyledFilterIcon = styled(FilterIcon)`
	margin-left: 0.8rem;
`

const StyledDrawer = styled(Drawer)`
	.MuiBackdrop-root {
		background-color: rgb(0, 0, 0, 0.679) !important;
	}
`

export {
	FilterButtonStyled,
	StyledCloseIcon,
	StyledDrawer,
	StyledFilterIcon,
	StyledTextButton,
}
